<template>
  <img
    :alt="$t.locationSelectorCurrentCountry"
    height="12"
    loading="lazy"
    :src="`/img/flags/${countryCode || defaultCountryCode}.svg`"
    width="18"
  >
</template>

<script lang="ts" setup>
defineProps<{ countryCode?: string }>()

const defaultCountryCode = useCountryCode()
</script>
